module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Menu_Main":{"pattern.snapMe.position":[{"value":69,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Menu_Main","_fox_":1}],"pattern.snapMe.title":[{"value":"My FanCentro","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Menu_Main","_fox_":1}],"pattern.snapMe.target":[{"value":"_blank","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.Menu_Main","_fox_":1}],"pattern.snapMe.checkers.snapMe.callback":[{"value":function (menuItem) {
var refCode = fox.getEnv('refCode');
if(!!refCode) {
menuItem.url = ['https://fancentro.com', 'r', refCode, fox.getEnv('scAlias')].join('/');
} else {
menuItem.url = ['https://fancentro.com', fox.getEnv('scAlias')].join('/');
}
return !fox.isEmpty(fox.getEnv('scAlias'));
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101017},"path":"~.Menu_Main","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/menu.js
// module id = 656
// module chunks = 4